/*
 * View for the action group mapping modal
 */
define([
  "marionette",
  "messaging/messenger",
  "modules/shared/actionGroupMappingModal/template/actionGroupMappingModalTemplate.html",
  "modules/typeahead/typeaheadModel",
], function (Marionette, Messenger, ActionGroupMappingModalTemplate, TypeaheadModel) {
  var ActionGroupMappingModalView = {};

  ActionGroupMappingModalView.actionGroupMappingModalLayout = Marionette.Layout.extend({
    template: ActionGroupMappingModalTemplate,
    regions: {
      actionGroupsList: "#navList",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    onRender: function () {
      this.$el.i18n();
      //set up source function to get the typeahead data
      var _this = this;
      var sourceFunction = function (query, process) {
        var results = Messenger.reqres.request("action:groups");
        results.once(
          "sync",
          function () {
            var variableArr = [];
            //get the action group names and build an array for the typeahead to process
            results.forEach(function (actionGroup) {
              variableArr.push(actionGroup.get("name"));
            });
            process(variableArr);
          },
          this,
        );
      };

      this.$el.find("input").typeahead({
        source: sourceFunction,
        updater: function (item) {
          //set the value of the textbox
          _this.$el.find("input").val(item);
          _this.trigger("select", item);
          return item;
        },
      });
    },
    clearError: function () {
      this.$el.find("#actionGroupError").html("");
    },
    actionGroupError: function (errorMessage) {
      this.$el
        .find("#actionGroupError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
  });

  return ActionGroupMappingModalView;
});
